<template>
  <div class="pick-contract row" v-loading="loading" style="margin:0;height:100%;">
    <div class="col-md-4 pick-contract__left">
      <IvanGroupProjectList
        :groups="groups"
        :current-xmbh="current && current.xmbh"
        @select="selectProject"
      />
    </div>
    <div class="col-md-8 pick-contract__right">
      <div v-if="!current" class="pick-contract__empty">
        <span class="text-muted">请选择待处理的采样任务</span>
      </div>
      <PickTaskEmbedPanel
        v-else
        :project="current"
        :rows="current.pickRows || []"
        @open-project="openProject"
        @submitted="onSubmitted"
        @need-refresh="softReload"
      />
    </div>
  </div>
</template>

<script>
import IvanGroupProjectList from '@/components/ivan/IvanGroupProjectList.vue'
import PickTaskEmbedPanel from '@/components/ivan/PickTaskEmbedPanel.vue'
import { fetchDoingPickBundle } from '@/utils/pickAdminAdapter'
import { collectSelectedPickIds, restorePickRowSelection, applyOverridesToRows } from '@/utils/pickAdapter'
import { pingTodoRefresh } from '@/utils/todoSync'

export default {
  name: 'PickBatchByContract',
  components: { IvanGroupProjectList, PickTaskEmbedPanel },
  data() {
    return {
      loading: false,
      groups: [],
      current: null,
      bundle: null
    }
  },
  mounted() {
    this.load()
  },
  activated() {
    this.softReload()
  },
  deactivated() {},
  beforeDestroy() {},
  watch: {
    '$route.query._r'() {
      this.load()
    },
    '$route.query.xmbh'(v) {
      if (!v || !this.bundle) return
      const hit = this.bundle.projectViews.find(p => p.xmbh === v)
      if (hit) this.current = hit
    }
  },
  methods: {
    async softReload() {
      try {
        const prevSelected = collectSelectedPickIds(this.current && this.current.pickRows)
        this.bundle = await fetchDoingPickBundle()
        this.groups = this.bundle.groups
        if (this.current && this.current.xmbh) {
          const hit = this.bundle.projectViews.find(p => p.xmbh === this.current.xmbh)
          if (hit) {
            applyOverridesToRows(hit.pickRows)
            restorePickRowSelection(hit.pickRows, prevSelected)
            this.current = hit
          }
        }
      } catch (e) { /* 静默 */ }
    },
    async load() {
      this.loading = true
      try {
        this.bundle = await fetchDoingPickBundle()
        this.groups = this.bundle.groups
        const q = this.$route.query.xmbh
        if (q) {
          const hit = this.bundle.projectViews.find(p => p.xmbh === q)
          this.current = hit || null
        } else if (this.current) {
          const hit = this.bundle.projectViews.find(p => p.xmbh === this.current.xmbh)
          this.current = hit || this.current
        }
      } catch (e) {
        this.groups = []
        this.$message.error('加载失败')
      } finally {
        this.loading = false
      }
    },
    selectProject(p) {
      this.current = p
      // 切项目时子面板会 watch project 拉 pending；这里顺带刷新 bundle 状态
      if (this.bundle && p && p.xmbh) {
        const hit = this.bundle.projectViews.find(x => x.xmbh === p.xmbh)
        if (hit) this.current = hit
      }
    },
    openProject(p) {
      if (p && p.xmbh) {
        this.$router.push({ path: '/entrust/' + encodeURIComponent(p.xmbh) })
      }
    },
    onSubmitted() {
      this.load()
      pingTodoRefresh()
    }
  }
}
</script>

<style scoped>
.pick-contract__left {
  height: calc(100% - 8px);
  overflow: auto;
  padding: 0;
  background: #fff;
}
.pick-contract__right {
  height: calc(100% - 8px);
  overflow: auto;
  background-color: #e9f0f5;
  padding: 5px;
}
.pick-contract__empty {
  background: #fff;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 50px 0;
}
</style>
